import React from 'react';
import { Spinner } from 'react-bootstrap';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
  fullScreen = false, 
  size = 'md',
  text = 'Loading...',
  variant = 'gold'
}) => {
  if (fullScreen) {
    return (
      <div className="spinner-fullscreen">
        <div className="spinner-content">
          <Spinner 
            animation="border" 
            className={`spinner-${variant} spinner-size-${size}`}
          />
          {text && <p className="spinner-text">{text}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="spinner-inline">
      <Spinner 
        animation="border" 
        className={`spinner-${variant} spinner-size-${size}`}
      />
      {text && <span className="spinner-text">{text}</span>}
    </div>
  );
};

export default LoadingSpinner;

